import { Controller } from "https://unpkg.com/@hotwired/stimulus@3.2.1/dist/stimulus.js";

class DiscountKitVolumeTiersController extends window.StimulusController {
  static targets = ["tier"];
  static values = {
    discountedPrice: String,
  };
  static outlets = ["price"];

  #updatePrice(price) {
    this.priceOutlet.updatePrice({
      price,
    });
  }

  setActiveTier(target) {
    const tierElement = target instanceof Event ? target.currentTarget : target;

    this.tierTargets.forEach((tier) => {
      tier.dataset.activeTier = "false";
    });
    tierElement.dataset.activeTier = "true";

    this.#updatePrice(tierElement.dataset.price);
  }

  setActiveTierByTierBuy(quantity) {
    this.tierTargets.forEach((tier, idx, tiers) => {
      const currentTierBuy = Number(tier.dataset.tierBuy);
      const nextTier = tiers[idx + 1];
      const nextTierBuy = nextTier
        ? Number(nextTier.dataset.tierBuy)
        : Infinity;

      const shouldBeActive =
        idx === 0
          ? quantity >= 1 && quantity < nextTierBuy
          : quantity >= currentTierBuy && quantity < nextTierBuy;

      if (shouldBeActive) {
        this.setActiveTier(tier);
      }
    });
  }
}

Stimulus.register(
  "discount-kit-volume-tiers",
  DiscountKitVolumeTiersController,
);
